"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TaskManagerProvider = exports.TaskManagerContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _hooks = require("../../hooks");
var _TaskManager = require("./TaskManager.labels");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var TaskManagerContext = /*#__PURE__*/_react.default.createContext({});
exports.TaskManagerContext = TaskManagerContext;
var TaskManagerProvider = function TaskManagerProvider(_ref) {
  var children = _ref.children;
  //const isActive = useRef(false);

  var getLabel = (0, _hooks.useLabels)({
    labels: _TaskManager.labels
  });
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobileView = _useDeviceData.isMobileView,
    isMobile = _useDeviceData.isMobile;
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    isPopupOpen = _useState2[0],
    setIsPopupOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isChanged = _useState4[0],
    setIsChanged = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isUpdate = _useState6[0],
    setIsUpdate = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    unitData = _useState8[0],
    setUnitData = _useState8[1];
  var _useState9 = (0, _react.useState)(true),
    _useState10 = _slicedToArray(_useState9, 2),
    isUnitDataLoading = _useState10[0],
    setIsUnitDataLoading = _useState10[1];
  var _useState11 = (0, _react.useState)(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isUnitDataError = _useState12[0],
    setIsUnitDataError = _useState12[1];
  var _useState13 = (0, _react.useState)(null),
    _useState14 = _slicedToArray(_useState13, 2),
    task = _useState14[0],
    setTask = _useState14[1];
  var _useState15 = (0, _react.useState)(null),
    _useState16 = _slicedToArray(_useState15, 2),
    originalTask = _useState16[0],
    setOriginalTask = _useState16[1];
  var _useState17 = (0, _react.useState)(true),
    _useState18 = _slicedToArray(_useState17, 2),
    isTaskLoading = _useState18[0],
    setIsTaskLoading = _useState18[1];
  var _useState19 = (0, _react.useState)(false),
    _useState20 = _slicedToArray(_useState19, 2),
    taskError = _useState20[0],
    setTaskError = _useState20[1];
  var _useState21 = (0, _react.useState)(false),
    _useState22 = _slicedToArray(_useState21, 2),
    isCloneItem = _useState22[0],
    setIsCloneItem = _useState22[1];
  var _useState23 = (0, _react.useState)(false),
    _useState24 = _slicedToArray(_useState23, 2),
    isCloneItemError = _useState24[0],
    setIsCloneItemError = _useState24[1];
  var _useState25 = (0, _react.useState)(false),
    _useState26 = _slicedToArray(_useState25, 2),
    isSavingItem = _useState26[0],
    setIsSavingItem = _useState26[1];
  var _useState27 = (0, _react.useState)(false),
    _useState28 = _slicedToArray(_useState27, 2),
    isSavedItem = _useState28[0],
    setIsSavedItem = _useState28[1];
  var _useState29 = (0, _react.useState)(false),
    _useState30 = _slicedToArray(_useState29, 2),
    isSaveItemError = _useState30[0],
    setIsSaveItemError = _useState30[1];
  var _useState31 = (0, _react.useState)(false),
    _useState32 = _slicedToArray(_useState31, 2),
    isShareItem = _useState32[0],
    setIsShareItem = _useState32[1];
  var _useState33 = (0, _react.useState)(null),
    _useState34 = _slicedToArray(_useState33, 2),
    onCloseData = _useState34[0],
    setOnCloseData = _useState34[1];
  var _useState35 = (0, _react.useState)(''),
    _useState36 = _slicedToArray(_useState35, 2),
    editTaskDataName = _useState36[0],
    setEditTaskDataName = _useState36[1];
  var _useState37 = (0, _react.useState)(''),
    _useState38 = _slicedToArray(_useState37, 2),
    editTaskDataGuideLines = _useState38[0],
    setEditTaskDataGuideLines = _useState38[1];
  var _useState39 = (0, _react.useState)(false),
    _useState40 = _slicedToArray(_useState39, 2),
    isEditTaskDataChanged = _useState40[0],
    setIsEditTaskDataChanged = _useState40[1];
  var _useState41 = (0, _react.useState)(false),
    _useState42 = _slicedToArray(_useState41, 2),
    isEditTaskDataOpened = _useState42[0],
    setIsEditTaskDataOpened = _useState42[1];
  var _useState43 = (0, _react.useState)(false),
    _useState44 = _slicedToArray(_useState43, 2),
    updateTaskTypeAfterExamStart = _useState44[0],
    setUpdateTaskTypeAfterExamStart = _useState44[1];
  var _useState45 = (0, _react.useState)(false),
    _useState46 = _slicedToArray(_useState45, 2),
    isChangedBackToExam = _useState46[0],
    setIsChangedBackToExam = _useState46[1];
  var _useState47 = (0, _react.useState)(false),
    _useState48 = _slicedToArray(_useState47, 2),
    reSubmitTaskAfterTaskTypeChanged = _useState48[0],
    setReSubmitTaskAfterTaskTypeChanged = _useState48[1];
  var _useState49 = (0, _react.useState)([]),
    _useState50 = _slicedToArray(_useState49, 2),
    readOnlyGroups = _useState50[0],
    setReadOnlyGroups = _useState50[1];
  var _useState51 = (0, _react.useState)([]),
    _useState52 = _slicedToArray(_useState51, 2),
    readOnlyStudents = _useState52[0],
    setReadOnlyStudents = _useState52[1];
  var _useState53 = (0, _react.useState)([]),
    _useState54 = _slicedToArray(_useState53, 2),
    selectedGroups = _useState54[0],
    setSelectedGroups = _useState54[1];
  var _useState55 = (0, _react.useState)([]),
    _useState56 = _slicedToArray(_useState55, 2),
    selectedStudents = _useState56[0],
    setSelectedStudents = _useState56[1];
  var _useState57 = (0, _react.useState)(false),
    _useState58 = _slicedToArray(_useState57, 2),
    isGroupsReadOnly = _useState58[0],
    setIsGroupsReadOnly = _useState58[1];
  var _useState59 = (0, _react.useState)(null),
    _useState60 = _slicedToArray(_useState59, 2),
    showReadOnlyMessageTiming = _useState60[0],
    setShowReadOnlyMessageTiming = _useState60[1];
  var _useState61 = (0, _react.useState)(null),
    _useState62 = _slicedToArray(_useState61, 2),
    showReadOnlyMessageGroups = _useState62[0],
    setShowReadOnlyMessageGroups = _useState62[1];
  var value = {
    // isActive: isActive,

    getLabel: getLabel,
    isMobileView: isMobileView,
    isMobile: isMobile,
    isPopupOpen: isPopupOpen,
    setIsPopupOpen: setIsPopupOpen,
    isChanged: isChanged,
    setIsChanged: setIsChanged,
    isUpdate: isUpdate,
    setIsUpdate: setIsUpdate,
    unitData: unitData,
    setUnitData: setUnitData,
    isUnitDataLoading: isUnitDataLoading,
    setIsUnitDataLoading: setIsUnitDataLoading,
    isUnitDataError: isUnitDataError,
    setIsUnitDataError: setIsUnitDataError,
    task: task,
    setTask: setTask,
    originalTask: originalTask,
    setOriginalTask: setOriginalTask,
    isTaskLoading: isTaskLoading,
    setIsTaskLoading: setIsTaskLoading,
    taskError: taskError,
    setTaskError: setTaskError,
    isCloneItem: isCloneItem,
    setIsCloneItem: setIsCloneItem,
    isCloneItemError: isCloneItemError,
    setIsCloneItemError: setIsCloneItemError,
    isSavingItem: isSavingItem,
    setIsSavingItem: setIsSavingItem,
    isSavedItem: isSavedItem,
    setIsSavedItem: setIsSavedItem,
    isSaveItemError: isSaveItemError,
    setIsSaveItemError: setIsSaveItemError,
    isShareItem: isShareItem,
    setIsShareItem: setIsShareItem,
    onCloseData: onCloseData,
    setOnCloseData: setOnCloseData,
    editTaskDataName: editTaskDataName,
    setEditTaskDataName: setEditTaskDataName,
    editTaskDataGuideLines: editTaskDataGuideLines,
    setEditTaskDataGuideLines: setEditTaskDataGuideLines,
    isEditTaskDataChanged: isEditTaskDataChanged,
    setIsEditTaskDataChanged: setIsEditTaskDataChanged,
    isEditTaskDataOpened: isEditTaskDataOpened,
    setIsEditTaskDataOpened: setIsEditTaskDataOpened,
    updateTaskTypeAfterExamStart: updateTaskTypeAfterExamStart,
    setUpdateTaskTypeAfterExamStart: setUpdateTaskTypeAfterExamStart,
    isChangedBackToExam: isChangedBackToExam,
    setIsChangedBackToExam: setIsChangedBackToExam,
    reSubmitTaskAfterTaskTypeChanged: reSubmitTaskAfterTaskTypeChanged,
    setReSubmitTaskAfterTaskTypeChanged: setReSubmitTaskAfterTaskTypeChanged,
    readOnlyGroups: readOnlyGroups,
    setReadOnlyGroups: setReadOnlyGroups,
    readOnlyStudents: readOnlyStudents,
    setReadOnlyStudents: setReadOnlyStudents,
    selectedGroups: selectedGroups,
    setSelectedGroups: setSelectedGroups,
    selectedStudents: selectedStudents,
    setSelectedStudents: setSelectedStudents,
    isGroupsReadOnly: isGroupsReadOnly,
    setIsGroupsReadOnly: setIsGroupsReadOnly,
    showReadOnlyMessageTiming: showReadOnlyMessageTiming,
    setShowReadOnlyMessageTiming: setShowReadOnlyMessageTiming,
    showReadOnlyMessageGroups: showReadOnlyMessageGroups,
    setShowReadOnlyMessageGroups: setShowReadOnlyMessageGroups
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(TaskManagerContext.Provider, {
    value: value,
    children: children
  });
};
exports.TaskManagerProvider = TaskManagerProvider;